// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
{
	"busDate": "",
	"checkAcceptState": 0,
	"costAmt": 0,
	"docNum": "",
	"invoDate": "",
	"nullifyB": 0,
	"payAmt": 0,
	"payState": 0,
	"printCnt": 0,
	"purcInvoCodg": "",
	"putinTypeId": 1,
	"remarks": "",
	"saleAmt": 0,
	"shedId": 2,
	"state": 0,
	"supplyCandidateId": '',
	"supplyCode": "",
	"tcmDocDetails": [
		{
			"drugId": '',
			"drugName":'',
			"expyDate": "",
			"id": '',
			"manuDate": "",
			"manuLotnum": "",
			"markUpId": 0,
			"markUpName": "",
			"maxPurcPric": 0,
			"maxSalePric": 0,
			"minPurcPric": 0,
			"minSalePric": 0,
			"nullifyCnt": 0,
			"nullifyDocId": 0,
			"nullifyId": 0,
			"nullifyState": 0,
			"nullifyTime": "",
			"nullifyWaitCnt": 0,
			"pacCnt": 0,
			"pacCUnt":'',
			"planId": '',
			"prodentpName": "",
			"prodentpNameId": 0,
			"purcAmt": 0,
			"purcCnt": 0,
			"purcPric": 0,
			"purcType": '2',
			"saleAmt": 0,
			"salePric": 0,
			"markUpPrice": 0,
			"markUpName":''
		}
	],
	"terminalId": ""
}
]

